module.exports = __webpack_public_path__ + "static/_uOfGuelphMain-00eb0924c3b5f3a11914efcab9273896.png";